import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const getMinimumDatePickerValue = (minimumDate) => {
  if (!minimumDate) return undefined;

  const minimum = dayjs(minimumDate, "DD-MM-YYYY", true);
  return minimum.isValid() ? minimum : undefined;
};

export const getDisabledDateBefore = (minimumDate) => {
  const minimum = getMinimumDatePickerValue(minimumDate);

  return (date) => Boolean(minimum && date.isBefore(minimum, "day"));
};
